import { Link as RouterLink } from 'react-router'

import QuestionCircleOutlinedIcon from '@ant-design/icons/QuestionCircleOutlined'

import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import { styled } from '@mui/material/styles'
import Link from '@components/_mui/Link'
import Typography from '@components/_mui/Typography'

import Avatar from '@components/Avatar'

export const styles = {
  container: {
    p: 2,
    height: '100%',
    width: '100%',
  },
}

export function PatientHeader({ user }) {
  return (
    <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
      <Avatar size="xl" user={user} hover="card" />
      <Stack>
        <Typography variant="h4">{user.fullName}</Typography>
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          <Link
            component={RouterLink}
            to={`/app/patients/${user.id}`}
            target="_blank"
            sx={{
              color: 'primary.main',
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            MRN: {user.id}
          </Link>
          {user.pronouns && <Typography sx={{ color: 'text.disabled' }}>•</Typography>}
          <Typography sx={{ color: 'text.secondary' }}>{user.pronouns}</Typography>
        </Stack>
      </Stack>
    </Stack>
  )
}

PatientHeader.Loading = function () {
  return (
    <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
      <Skeleton variant="rounded" width={64} height={64} />
      <Stack>
        <Typography variant="h4">
          <Skeleton width={200} />
        </Typography>
        <Typography>
          <Skeleton width={150} />
        </Typography>
      </Stack>
    </Stack>
  )
}

export const FAQIcon = styled(QuestionCircleOutlinedIcon)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: 18,
}))
